import { render, staticRenderFns } from "./AdminForgottenPassword.vue?vue&type=template&id=626bc416&scoped=true&"
import script from "./AdminForgottenPassword.vue?vue&type=script&lang=js&"
export * from "./AdminForgottenPassword.vue?vue&type=script&lang=js&"
import style0 from "./AdminForgottenPassword.vue?vue&type=style&index=0&id=626bc416&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626bc416",
  null
  
)

export default component.exports